import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  logout_user_action,
  user_meta_data_action,
} from "../../../redux/_actions";
import { useNavigate } from "react-router-dom";
import { commonHeaderDropdown, signedInHeaderDropdown } from "./constants";
function useHeader(props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const userInLocalStorage = JSON.parse(localStorage.getItem("jigsawUser"));
  const [loading, setLoading] = useState(false);
  const [formInputsError, setFormInputsError] = useState({});
  const [headerDropdown, setHeaderDropdown] = useState([]);
  const [userRole, setUserRole] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const menuOpenHandler = () => {
    setMenuOpen(!menuOpen);
  };

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  useEffect(() => {
    getUserMetaData();
  }, []);

  useEffect(() => {
    if (userMetaData) {
      if (userMetaData?.id) setHeaderDropdown(signedInHeaderDropdown);
      if (userMetaData?.role) setUserRole(userMetaData?.role);
    } else setHeaderDropdown(commonHeaderDropdown);
  }, [userMetaData]);

  // calendarAvailabilityListsData
  const getUserMetaData = async () => {
    await dispatch(user_meta_data_action());
  };

  const onSignOutClick = async () => {
    setLoading(true);

    if (userInLocalStorage && userInLocalStorage.refresh_token) {
      let data = { refresh: userInLocalStorage.refresh_token };
      await dispatch(logout_user_action(data));
      checkNavigate();
    }

    setLoading(false);
  };

  //navigate to screens
  const checkNavigate = (loginData) => {
    // success
    if (loginData !== null) {
      navigate("/sign-in");
    } else {
      let form_errors = {
        ...formInputsError,
        formSubmitError: "Can not create company.",
      };
      setFormInputsError(form_errors);
    }
  };

  const viewProfile = () => {
    if (userMetaData) {
      if (userMetaData?.role === "candidate") {
        navigate("/candidate-profile");
      } else if (userMetaData?.role === "mentor") {
        navigate("/mentor-profile");
      } else if (userMetaData?.role === "hiring_manager") {
        navigate("/hiring-manager-profile");
      }
    }
  };

  const viewNotifications = async () => {
    navigate("/notifications");
  };
  const viewBucketList = async () => {
    navigate("/bucket-list");
  };

  const viewJobBoard = () => {
    if (userMetaData) {
      if (userMetaData?.role === "hiring_manager") {
        navigate("/hiring-manager-jobs");
      } else {
        navigate("/job-board");
      }
    }
  };

  const viewMentors = async () => {
    navigate("/all-mentors");
  };

  const viewCandidates = async () => {
    navigate("/all-candidates");
  };

  const viewCompanies = async () => {
    navigate("/companies");
  };

  const onDemoViewClick = () => {
    navigate("/");
  };
  const viewSharedBucket = () => {
    navigate("/shared-bucket-list");
  };
  const viewHiringPipeline = () => {
    if (userMetaData && userMetaData?.role === "mentor") {
      navigate("/hiring-pipeline");
    } else {
      navigate("/hiring-manager-jobs");
    }
  };

  const viewAssessmentkits = () => {
    navigate("/mentor-assessment-kits");
  };
  const viewDashboardClick = () => {
    if (userMetaData?.role === "mentor")
      navigate("/mentor-dashboard");
    else if (userMetaData?.role === "candidate")
      navigate("/candidate-dashboard");
    else navigate("/hiring-manager-dashboard");
  };
  return {
    menuOpen,
    loading,
    userMetaData,
    headerDropdown,

    menuOpenHandler,
    onSignOutClick,
    viewProfile,
    viewNotifications,
    viewJobBoard,
    viewMentors,
    viewCandidates,
    viewCompanies,
    onDemoViewClick,
    viewBucketList,
    viewSharedBucket,
    viewHiringPipeline,
    viewAssessmentkits,viewDashboardClick
  };
}
export default useHeader;
